import { DEVICE_OS, DEVICE_TYPES } from './constants/AppConstants';

export const getDeviceType = (userAgent: string) => {
  if (/(tablet|ipad|playbook|silk)|(android(?!.*mobi))/i.test(userAgent)) {
    return DEVICE_TYPES.TABLET;
  } else if (
    /Mobile|Android|iP(hone|od)|IEMobile|BlackBerry|Kindle|Silk-Accelerated|(hpw|web)OS|Opera M(obi|ini)/.test(
      userAgent
    )
  ) {
    return DEVICE_TYPES.MOBILE;
  } else {
    return DEVICE_TYPES.DESKTOP;
  }
};

export const getDeviceOS = () => {
  const userAgent = navigator.userAgent || navigator.vendor;
  if (userAgent.match(/Android/i)) {
    return DEVICE_OS.ANDRIOD;
  } else if (
    userAgent.match(/iPhone/i) ||
    userAgent.match(/iPad/i) ||
    userAgent.match(/iPod/i)
  ) {
    return DEVICE_OS.IOS;
  } else {
    return DEVICE_OS.WEB;
  }
};

export const isWebView = () => {
  if (
    typeof window !== undefined &&
    (window.zee5 ||
      (window.webkit &&
        window.webkit.messageHandlers &&
        window.webkit.messageHandlers.zee5))
  ) {
    return true;
  } else {
    return false;
  }
};
